import { useMemo } from "react";
import { useUnifiedStore } from "../store/StoreContext";
import { resolveSystemTypeConfig } from "../utils/resolveSystemTypeConfig";
export { resolveSystemTypeConfig } from "../utils/resolveSystemTypeConfig";
export function useSystemTypeConfig() {
    const activeSystemType = useUnifiedStore((s) => s.activeSystemType);
    return useMemo(() => resolveSystemTypeConfig(activeSystemType), [activeSystemType]);
}
